"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldWrapper = void 0;
const react_1 = __importDefault(require("react"));
exports.FormFieldWrapper = ({ label, description, errors, children, className }) => (react_1.default.createElement("div", { className: `form__wrapper ${className || ""}` },
    !!label ? react_1.default.createElement("div", { className: "form__label" }, label) : null,
    !!description ? react_1.default.createElement("div", { className: "form__description" }, description) : null,
    react_1.default.createElement("div", { className: "form__field" }, children),
    !!errors && errors.length > 0 ? react_1.default.createElement("div", { className: "form__errors" }, errors.map((e) => e.code).join(". ")) : null));
//# sourceMappingURL=FieldWrapper.js.map